var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-box"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.stepShow)?_c('BdoProgress',{attrs:{"step":_vm.step,"total":_vm.total}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }